// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ExpandableClamp__label":"bca_a bia_hi bia_sa bia_xl"};